export const searchService = {
  getRequest: function (
    filters,
    originalFilters,
    token,
    locationFilterValue,
    radiusFilterValue,
    keywordFilterValue
  ) {
    const JOB_SEARCH_TELECOMMUTE_PREFERENCE_UNSPECIFIED = 0,
      JOB_SEARCH_TELECOMMUTE_PREFERENCE_ALLOWED = 1,
      // eslint-disable-next-line
      JOB_SEARCH_TELECOMMUTE_PREFERENCE_EXCLUDED = 2;

    var requestBody = {
      queryString: filters.queryString || keywordFilterValue,
      enableSpellCheck: true,
      userId: localStorage.getItem("uid"),
      sessionId: sessionStorage.getItem("sid"),
    };

    if (token) {
      requestBody.nextPageToken = token;
    }

    requestBody.location = {
      telecommute: filters.remoteWorking
        ? JOB_SEARCH_TELECOMMUTE_PREFERENCE_ALLOWED
        : JOB_SEARCH_TELECOMMUTE_PREFERENCE_UNSPECIFIED,
    };

    if (locationFilterValue) {
      var radiusValue = parseInt(radiusFilterValue);
      requestBody.location.address = locationFilterValue;
      requestBody.location.distanceInMiles = radiusFilterValue
        ? isNaN(radiusValue)
          ? 0
          : radiusValue
        : 0;
    } else {
      requestBody.location.address = filters.location;
      if (filters.distance !== "")
        requestBody.location.distanceInMiles = filters.distance;
    }

    if (filters.commute) {
      requestBody.commute = { roadTraffic: 2 };

      if (filters.commute.method) {
        requestBody.commute.method = filters.commute.method.id;
      }

      if (filters.commute.startingLocation) {
        requestBody.commute.start = {
          latitude: filters.commute.startingLocation?.latlng?.lat,
          longitude: filters.commute.startingLocation?.latlng?.lng,
        };
      }

      if (filters.commute.travelTime) {
        requestBody.commute.travelDuration = filters.commute.travelTime * 60;
      } else {
        requestBody.commute = null;
      }
    }

    if (filters.salary?.type?.id) {
      requestBody.compensation = {
        type: 2,
        units: parseInt(filters.salary.type.id),
        range: {
          minimum: {
            amount: filters.salary.minimum,
            currencyCode: filters.salary.currencyCode,
          },
        },
        IncludeJobsWithUnspecifiedCompensationRange: false,
      };
    }

    if (originalFilters.histograms?.length > 0) {
      requestBody.histograms = originalFilters.histograms;
    }

    requestBody.jobTypes = filters.jobTypes?.map((x) => x?.key);

    requestBody.sectors = filters.customStringAttributes?.map((x) => {
      return { id: x?.id, name: x?.name };
    });

    for (var i = 1; i <= 4; i++)
      requestBody[`customStringAttributes${i}`] = filters[
        `customStringAttributes${i}`
      ]?.map((x) => {
        return { id: x?.id, name: x?.name, predefinedId: x?.predefinedId };
      });

    return requestBody;
  },
};

export default searchService;
